import { gql, MutationTuple, useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { useToast } from '@televet/kibble-ui';
import { MutationUpdateOneChannelArgs, Channel } from 'shared/types/graphql';

const UPDATE_TEAM_CHANNEL = gql`
  mutation updateTeamChannel($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
    updateTeamChannel2(where: $where, data: $data) {
      id
      isActive
      friendlyName
    }
  }
`;

export const useUpdateTeamChannel = (): MutationTuple<
  { updateTeamChannel2: Channel },
  MutationUpdateOneChannelArgs
> => {
  const toast = useToast();

  return useMutation(UPDATE_TEAM_CHANNEL, {
    onCompleted: (data) => {
      const friendlyName = data?.updateTeamChannel2?.friendlyName;
      toast({
        status: 'success',
        description: `Success! The ${friendlyName} team channel was updated`,
        duration: 5000,
      });
    },
    onError: (error) => {
      console.error(error);
      Sentry.captureException(error);
      toast({
        status: 'error',
        description: 'Whoops! An error occurred while updating the team channel. Please try again.',
        duration: 5000,
      });
    },
  });
};
